// extracted by mini-css-extract-plugin
export var cartContainer = "_jw-4";
export var gray = "_jw-1";
export var itemContainer = "_jw-2";
export var itemDetails = "_jw-3";
export var strong = "_jw-0";